import React from 'react';
import { Button, Typography } from '@icecreamsocial/components';
import { ShareIcon } from '../SupportedIcons';
import { webShare, isMobileOrTablet } from '../../../utils';
import { useIntl } from 'react-intl';

export const WebShareButton = ({ link, title, text, ...rest }) => {
	const intl = useIntl();

	/**
	 * localization
	 */
	const SHARE = intl.formatMessage({
		id: 'button.share',
		defaultMessage: 'Share',
		description:
			'Call to action text for a user to share a link via built in web share options',
	});

	return (
		<Button
			display='flex'
			alignItems='center'
			backgroundColor='accent'
			textColor='bodyInverse'
			paddingLeft={['md']}
			paddingRight={['md']}
			onClick={() => {
				webShare({
					url: link,
					title,
					text,
				});
			}}
			style={{ gap: '8px' }}
			{...rest}
		>
			<ShareIcon size={18} />
			<Typography.Span
				typoSize='1.1em'
				display={['inline-block', 'inline-block', 'none']}
			>
				{SHARE}
			</Typography.Span>
		</Button>
	);
};
